/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../cash/crypto/amount';
import '../common/currency';
import '../../google/protobuf/duration';
import '../../google/protobuf/timestamp';
import '../bankc/model';
import '../common/time';
import '../paymentbalances/common';
import '../common/currency_codes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bitty": {
        "nested": {
          "RequirementId": {
            "values": {
              "DO_NOT_USE_REQUIREMENT_ID": 0,
              "SCAM_WARNING": 1,
              "SPEED": 2,
              "SCAM_WARNING_CANCELLED": 3,
              "USER_CONFIRMATION": 4,
              "AMOUNT": 5,
              "NOTE": 6,
              "SANCTIONS_WITHDRAWAL_REASON": 7,
              "SANCTIONS_HELD": 8,
              "OBSERVED_IN_MEMPOOL": 9,
              "CONFIRMED_ON_CHAIN": 10,
              "SELF_ATTESTATION": 11,
              "SUBMITTED_ON_CHAIN": 12,
              "TARGET_WALLET_ADDRESS": 13
            }
          },
          "ResultCode": {
            "values": {
              "DO_NOT_USE_RESULT_CODE": 0,
              "CLEARED": 1,
              "FAILED_RESULT": 2,
              "CANCELLED": 3,
              "SKIPPED": 4,
              "BACK": 5,
              "FINISHED_OK": 6,
              "FINISHED_ERROR": 7
            }
          },
          "UserInteraction": {
            "fields": {
              "requirementId": {
                "type": ".squareup.bitty.RequirementId",
                "id": 1,
                "rule": "optional"
              },
              "hurdle": {
                "type": ".squareup.bitty.Hurdle",
                "id": 2
              },
              "notification": {
                "type": ".squareup.bitty.Notification",
                "id": 3
              }
            },
            "nested": {
              "user_interaction": {
                "oneof": ["hurdle", "notification"]
              }
            }
          },
          "Hurdle": {
            "fields": {
              "amountHurdle": {
                "type": ".squareup.bitty.AmountHurdle",
                "id": 1
              },
              "confirmationHurdle": {
                "type": ".squareup.bitty.ConfirmationHurdle",
                "id": 2
              },
              "noteHurdle": {
                "type": ".squareup.bitty.NoteHurdle",
                "id": 3
              },
              "scamWarningHurdle": {
                "type": ".squareup.bitty.ScamWarningHurdle",
                "id": 4
              },
              "selfAttestationHurdle": {
                "type": ".squareup.bitty.SelfAttestationHurdle",
                "id": 5
              },
              "speedHurdle": {
                "type": ".squareup.bitty.SpeedHurdle",
                "id": 6
              },
              "withdrawalReasonHurdle": {
                "type": ".squareup.bitty.WithdrawalReasonHurdle",
                "id": 7
              },
              "targetWalletAddressHurdle": {
                "type": ".squareup.bitty.TargetWalletAddressHurdle",
                "id": 8
              }
            },
            "nested": {
              "hurdle": {
                "oneof": ["amountHurdle", "confirmationHurdle", "noteHurdle", "scamWarningHurdle", "selfAttestationHurdle", "speedHurdle", "withdrawalReasonHurdle", "targetWalletAddressHurdle"]
              }
            }
          },
          "AmountHurdle": {
            "fields": {
              "balance": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 1,
                "rule": "optional"
              },
              "displayUnits": {
                "type": ".squareup.bitty.BitcoinDisplayPreference",
                "id": 2,
                "rule": "optional"
              },
              "walletAddress": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "minimumAmount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 4,
                "rule": "optional"
              },
              "maximumAmount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 6,
                "rule": "optional"
              },
              "maximumAmountFiatEquivalent": {
                "type": ".squareup.common.Money",
                "id": 8,
                "rule": "optional"
              },
              "maximumAmountReason": {
                "type": ".squareup.bitty.MaximumAmountReason",
                "id": 7,
                "rule": "optional"
              },
              "exchangeRate": {
                "type": ".squareup.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "previousAmount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 9,
                "rule": "optional"
              }
            }
          },
          "MaximumAmountReason": {
            "values": {
              "DO_NOT_USE_MAR": 0,
              "BALANCE": 1,
              "DAILY_LIMIT": 2,
              "WEEKLY_LIMIT": 3
            }
          },
          "ConfirmationHurdle": {
            "fields": {
              "selectedSpeed": {
                "type": ".squareup.bitty.WithdrawalSpeedOption",
                "id": 1,
                "rule": "optional"
              },
              "walletAddress": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "amount": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "fiatEquivalent": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "totalFee": {
                "type": ".squareup.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "totalFeeFiatEquivalent": {
                "type": ".squareup.common.Money",
                "id": 6,
                "rule": "optional"
              },
              "total": {
                "type": ".squareup.common.Money",
                "id": 7,
                "rule": "optional"
              },
              "displayUnits": {
                "type": ".squareup.bitty.BitcoinDisplayPreference",
                "id": 8,
                "rule": "optional"
              },
              "note": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "balance": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 10,
                "rule": "optional"
              },
              "exchangeRate": {
                "type": ".squareup.common.Money",
                "id": 11,
                "rule": "optional"
              }
            }
          },
          "NoteHurdle": {
            "fields": {
              "previousNote": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "maxNoteLength": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ScamWarningHurdle": {
            "fields": {}
          },
          "SelfAttestationHurdle": {
            "fields": {
              "exchangeOptions": {
                "type": ".squareup.bitty.SelfAttestationExchangeOption",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "TargetWalletAddressHurdle": {
            "fields": {
              "previousTargetWalletAddress": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "SpeedHurdle": {
            "fields": {
              "withdrawalSpeedOptions": {
                "type": ".squareup.bitty.WithdrawalSpeedOption",
                "id": 1,
                "rule": "repeated"
              },
              "balance": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 2,
                "rule": "optional"
              },
              "freeTierMinimum": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 3,
                "rule": "optional"
              },
              "displayUnits": {
                "type": ".squareup.bitty.BitcoinDisplayPreference",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "WithdrawalReasonHurdle": {
            "fields": {
              "maxWithdrawalReasonLength": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "Notification": {
            "fields": {
              "withdrawalCancelledNotification": {
                "type": ".squareup.bitty.CancelledNotification",
                "id": 1
              },
              "withdrawalSanctionsHeldNotification": {
                "type": ".squareup.bitty.SanctionsHeldNotification",
                "id": 2
              },
              "submittedOnChainNotification": {
                "type": ".squareup.bitty.SubmittedOnChainNotification",
                "id": 3
              }
            },
            "nested": {
              "notification": {
                "oneof": ["withdrawalCancelledNotification", "withdrawalSanctionsHeldNotification", "submittedOnChainNotification"]
              }
            }
          },
          "CancelledNotification": {
            "fields": {}
          },
          "SanctionsHeldNotification": {
            "fields": {}
          },
          "SubmittedOnChainNotification": {
            "fields": {
              "amount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 1,
                "rule": "optional"
              },
              "displayUnits": {
                "type": ".squareup.bitty.BitcoinDisplayPreference",
                "id": 2,
                "rule": "optional"
              },
              "fiatEquivalent": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "estimatedCompletionTime": {
                "type": ".google.protobuf.Duration",
                "id": 4,
                "rule": "optional"
              },
              "targetWalletAddress": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "WithdrawalAction": {
            "fields": {
              "requirementId": {
                "type": ".squareup.bitty.RequirementId",
                "id": 1,
                "rule": "optional"
              },
              "resultCode": {
                "type": ".squareup.bitty.ResultCode",
                "id": 2,
                "rule": "optional"
              },
              "speedAction": {
                "type": ".squareup.bitty.SpeedActionData",
                "id": 3
              },
              "withdrawalReasonAction": {
                "type": ".squareup.bitty.WithdrawalReasonActionData",
                "id": 4
              },
              "amountAction": {
                "type": ".squareup.bitty.AmountActionData",
                "id": 5
              },
              "noteAction": {
                "type": ".squareup.bitty.NoteActionData",
                "id": 6
              },
              "selfAttestationAction": {
                "type": ".squareup.bitty.SelfAttestationActionData",
                "id": 7
              },
              "targetWalletAddressAction": {
                "type": ".squareup.bitty.TargetWalletAddressActionData",
                "id": 8
              }
            },
            "nested": {
              "withdrawal_action": {
                "oneof": ["speedAction", "withdrawalReasonAction", "amountAction", "noteAction", "selfAttestationAction", "targetWalletAddressAction"]
              }
            }
          },
          "SpeedActionData": {
            "fields": {
              "selectedSpeed": {
                "type": ".squareup.bitty.WithdrawalSpeed",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "WithdrawalReasonActionData": {
            "fields": {
              "reason": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "AmountActionData": {
            "fields": {
              "userAmount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "NoteActionData": {
            "fields": {
              "note": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "SelfAttestationActionData": {
            "fields": {
              "destination": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "ownWallet": {
                "type": ".squareup.bitty.OwnWalletType",
                "id": 2
              },
              "exchange": {
                "type": ".squareup.bitty.TrustHubExchangeName",
                "id": 3
              },
              "exchangeAccount": {
                "type": ".squareup.bitty.ExchangeAccount",
                "id": 4
              }
            },
            "nested": {
              "own_wallet_or_exchange": {
                "oneof": ["ownWallet", "exchange", "exchangeAccount"]
              }
            }
          },
          "ExchangeAccount": {
            "fields": {
              "exchangeAccountType": {
                "type": ".squareup.bitty.ExchangeAccountType",
                "id": 1,
                "rule": "optional"
              },
              "exchange": {
                "type": ".squareup.bitty.TrustHubExchangeName",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "TargetWalletAddressActionData": {
            "fields": {
              "targetWalletAddress": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "WithdrawalSpeedOption": {
            "fields": {
              "speed": {
                "type": ".squareup.bitty.WithdrawalSpeed",
                "id": 1,
                "rule": "optional"
              },
              "fee": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 2,
                "rule": "optional"
              },
              "feeFiatEquivalent": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "estimatedCompletionTime": {
                "type": ".google.protobuf.Duration",
                "id": 4,
                "rule": "optional"
              },
              "selectable": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "adjustedAmount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 6,
                "rule": "optional"
              },
              "adjustedAmountFiatEquivalent": {
                "type": ".squareup.common.Money",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "SelfAttestationExchangeOption": {
            "fields": {
              "exchangeOption": {
                "type": ".squareup.bitty.TrustHubExchangeName",
                "id": 1,
                "rule": "optional"
              },
              "exchangeName": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "grouping": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "WithdrawalSimpleState": {
            "values": {
              "DO_NOT_USE_WState": 0,
              "SUBMITTED": 1,
              "PENDING": 2,
              "COMPLETE": 3,
              "FAILED_WITHDRAWAL": 4,
              "UNDER_REVIEW": 5,
              "SANCTIONED_WITHDRAWAL": 6
            }
          },
          "DepositSimpleState": {
            "values": {
              "DO_NOT_USE_DState": 0,
              "PENDING_DEPOSIT": 1,
              "COMPLETE_DEPOSIT": 2,
              "REVERSED": 3,
              "PENDING_REVERSAL": 4,
              "FAILED_DEPOSIT": 5
            }
          },
          "WithdrawalState": {
            "values": {
              "DO_NOT_USE": 0,
              "COLLECTING_INFO": 1,
              "CHECKING_RISK": 2,
              "COLLECTING_SCAM_WARNING_DECISION": 3,
              "CONFIRMED_COMPLETE": 10,
              "COLLECTING_SANCTIONS_INFO": 24,
              "CHECKING_SANCTIONS": 11,
              "WAITING_FOR_SANCTIONS_HELD_DECISION": 12,
              "CHECKING_TRAVEL_RULE": 13,
              "COLLECTING_SELF_ATTESTATION": 14,
              "CHECKING_ELIGIBILITY": 25,
              "HOLDING_SUBMISSION": 15,
              "SUBMITTING_ON_CHAIN": 16,
              "WAITING_FOR_PENDING_CONFIRMATION_STATUS": 17,
              "WAITING_FOR_CONFIRMED_ON_CHAIN_STATUS": 18,
              "FAILED": 22,
              "SANCTIONED": 23
            }
          },
          "DepositState": {
            "values": {
              "DO_NOT_USE_DEPOSIT_STATE": 0,
              "DETECTING_ON_CHAIN": 1,
              "VALIDATING_DEPOSIT": 2,
              "CHECKING_DEPOSIT_RISK": 3,
              "CHECKING_DEPOSIT_SANCTIONS": 4,
              "WAITING_FOR_DEPOSIT_REVIEW_DECISION": 5,
              "WAITING_FOR_CONFIRMATIONS": 6,
              "CONFIRMING_DEPOSIT": 7,
              "CREDITING_ACCOUNT": 8,
              "DEPOSIT_CONFIRMED_COMPLETE": 9,
              "PENDING_DEPOSIT_REVERSAL": 10,
              "REVERSING_DEPOSIT": 11,
              "DEPOSIT_REVERSED": 12,
              "DEPOSIT_FAILED": 13,
              "DEPOSIT_SANCTIONED": 14,
              "DEPOSIT_NEW": 15,
              "DEPOSIT_AWAITING_DEPOSIT_CONFIRMATION": 16,
              "DEPOSIT_EVICTED": 17,
              "DEPOSIT_CHECKING_ELIGIBILITY": 18,
              "DEPOSIT_COLLECTING_SANCTIONS_INFO": 19,
              "DEPOSIT_AWAITING_SANCTIONS_DECISION": 20,
              "DEPOSIT_CREATING_DEPOSIT_TRANSACTION": 21,
              "DEPOSIT_SETTLED": 22,
              "DEPOSIT_PENDING_REVERSAL": 23,
              "DEPOSIT_CHECKING_REVERSAL_RISK": 24,
              "DEPOSIT_AWAITING_REVERSAL_PENDING_CONFIRMATION": 25,
              "DEPOSIT_AWAITING_REVERSAL_CONFIRMATION": 26,
              "DEPOSIT_VOIDED": 27
            }
          },
          "WithdrawalFailureReason": {
            "values": {
              "DO_NOT_USE_FAILURE_REASON": 0,
              "UNKNOWN": 1,
              "CUSTOMER_CANCELLED": 2,
              "RISK_BLOCKED": 3,
              "LIMITED": 4,
              "STEP_UP_AUTHENTICATION_FAILED": 5,
              "SANCTIONS_DECLINED": 6,
              "CUSTOMER_DECLINED_DUE_TO_SCAM_WARNING": 8,
              "SANCTIONS_FAILED": 9,
              "INSUFFICIENT_FUNDS": 10,
              "CUSTOMER_IS_INELIGIBLE": 11,
              "ADMIN_FAILED": 12,
              "FAILED_ON_CHAIN": 13,
              "CUSTOMER_ABANDONED": 14
            }
          },
          "DepositFailureReason": {
            "values": {
              "DO_NOT_USE_DEPOSIT_FAILURE_REASON": 0,
              "DEPOSIT_UNKNOWN": 1,
              "DEPOSIT_RISK_BLOCKED": 2,
              "DEPOSIT_SANCTIONS_DECLINED": 3,
              "DEPOSIT_SANCTIONS_FAILED": 4,
              "DEPOSIT_BLOCKCHAIN_ERROR": 5,
              "DEPOSIT_CUSTOMER_IS_INELIGIBLE": 6,
              "DEPOSIT_ADMIN_FAILED": 7,
              "DEPOSIT_INVALID": 8,
              "DEPOSIT_BELOW_MINIMUM": 9,
              "DEPOSIT_COMPLIANCE_REVERSAL": 10
            }
          },
          "WithdrawalSpeed": {
            "values": {
              "DO_NOT_USE_WSPEED": 0,
              "PRIORITY": 1,
              "RUSH": 2,
              "STANDARD": 3
            }
          },
          "ExchangeDetail": {
            "fields": {
              "exchangeToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "exchangeType": {
                "type": ".squareup.bitty.ExchangeDetail.ExchangeType",
                "id": 2,
                "rule": "optional"
              },
              "exchangeTime": {
                "type": ".google.protobuf.Timestamp",
                "id": 3,
                "rule": "optional"
              },
              "exchangeRate": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "sourceAmount": {
                "type": ".squareup.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "targetAmount": {
                "type": ".squareup.common.Money",
                "id": 6,
                "rule": "optional"
              },
              "feeAmount": {
                "type": ".squareup.common.Money",
                "id": 7,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "accountToken": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "exchangeState": {
                "type": ".squareup.bitty.ExchangeDetail.ExchangeState",
                "id": 11,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 12,
                "rule": "optional"
              },
              "bankcTransactionId": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "paybalTransactionId": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "bitplatOrderToken": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              },
              "temporalWorkflowId": {
                "type": "string",
                "id": 16,
                "rule": "optional"
              },
              "quotedExchangeRate": {
                "type": "int64",
                "id": 17,
                "rule": "optional"
              },
              "bankcBalanceName": {
                "type": "string",
                "id": 18,
                "rule": "optional"
              },
              "bankcBalanceProvider": {
                "type": ".squareup.bankc.BalanceProvider",
                "id": 19,
                "rule": "optional"
              },
              "reversesExchangeId": {
                "type": "int64",
                "id": 20,
                "rule": "optional"
              },
              "reversedByExchangeToken": {
                "type": "string",
                "id": 21,
                "rule": "optional"
              },
              "bankcProviderMovementProcessingIdentifier": {
                "type": "string",
                "id": 22,
                "rule": "optional"
              },
              "conversionData": {
                "type": ".squareup.bitty.ExchangeDetail.ConversionData",
                "id": 8
              }
            },
            "nested": {
              "ExchangeType": {
                "values": {
                  "DO_NOT_USE_EXCHANGE_TYPE": 0,
                  "CONVERSION": 1,
                  "MANUAL_BUY": 2,
                  "MANUAL_SELL": 3,
                  "PROMO_REWARD": 4,
                  "BTC_INSTANT_LIQUIDATION": 5
                }
              },
              "ExchangeState": {
                "values": {
                  "DO_NOT_USE_EXCHANGE_STATE": 0,
                  "INITIATED": 1,
                  "AMOUNT_CALCULATED": 2,
                  "COMPLETED": 3,
                  "CANCELLED_INSUFFICIENT_BALANCE": 4,
                  "FAILED": 5,
                  "COMPLETED_UNIT_REPORTING_FAILED": 6,
                  "FAILED_ELIGIBILITY": 7,
                  "FAILED_QUOTE_EXPIRED": 8,
                  "FAILED_RISK": 9
                }
              },
              "ConversionData": {
                "fields": {
                  "withholdingBps": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitsWithheldFromCount": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ExchangeMetadata": {
                "oneof": ["conversionData"]
              }
            }
          },
          "BitcoinTransactionType": {
            "fields": {
              "exchangeType": {
                "type": ".squareup.bitty.ExchangeDetail.ExchangeType",
                "id": 1
              },
              "paymentType": {
                "type": ".squareup.bitty.BitcoinTransactionType.PaymentType",
                "id": 2
              }
            },
            "nested": {
              "PaymentType": {
                "values": {
                  "DO_NOT_USE_PT": 0,
                  "LIGHTNING": 1
                }
              },
              "transaction_type": {
                "oneof": ["exchangeType", "paymentType"]
              }
            }
          },
          "SourceTargetBalance": {
            "fields": {
              "balanceId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "balanceProvider": {
                "type": ".squareup.bankc.BalanceProvider",
                "id": 2,
                "rule": "optional"
              },
              "balanceName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "Endpoint": {
            "values": {
              "DO_NOT_USE_ENDPOINT": 0,
              "EXECUTE": 1,
              "SECURE_EXECUTE": 2
            }
          },
          "BusinessType": {
            "values": {
              "DO_NOT_USE_BT": 0,
              "BUSINESS_TYPE_UNSPECIFIED": 1,
              "INDIVIDUAL": 2,
              "SINGLE_MEMBER_LLC": 3,
              "LLC": 4,
              "PRIVATE_COMPANY": 5,
              "PUBLIC_COMPANY_UNLISTED": 6,
              "PUBLIC_COMPANY_LISTED": 7,
              "PARTNERSHIP": 8
            }
          },
          "CurrencyDisplayPreference": {
            "values": {
              "DO_NOT_USE_CDP": 0,
              "USD": 1,
              "BTC": 2
            }
          },
          "BitcoinAccountStatus": {
            "values": {
              "DO_NOT_USE_BITCOIN_ACCOUNT_ELIGIBILITY": 0,
              "INELIGIBLE": 1,
              "ENROLLABLE": 2,
              "WAITLISTABLE": 3,
              "WAITLISTED": 4,
              "ELIGIBLE": 5,
              "ACTIVE": 6,
              "DEACTIVATED": 7,
              "MANUALLY_ONBOARDED": 8,
              "FROZEN": 9,
              "REGULATORY_RESTRICTED": 10,
              "REGULATORY_RESTRICTED_LAPSED": 11
            }
          },
          "BtcKybStatus": {
            "values": {
              "DO_NOT_USE_BKS": 0,
              "PASSED": 1,
              "UNEVALUATED": 2,
              "DECLINED": 3,
              "IN_PROGRESS": 4
            }
          },
          "BitcoinDisplayPreference": {
            "values": {
              "DO_NOT_USE_BDP": 0,
              "BITCOIN": 1,
              "SATOSHI": 2
            }
          },
          "BitcoinPaymentsStatus": {
            "values": {
              "DO_NOT_USE_BPS": 0,
              "ENABLED": 1,
              "DISABLED": 2,
              "BITCOIN_PAYMENTS_ELIGIBLE": 3
            }
          },
          "BitcoinActivity": {
            "fields": {
              "paymentBalanceTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "clientMemo": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "fiatAmount": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "btcAmount": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "completionDateGroup": {
                "type": ".squareup.common.time.YearMonthDay",
                "id": 5,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.paymentbalances.ActivityType",
                "id": 6,
                "rule": "optional"
              },
              "exchangeToken": {
                "type": "string",
                "id": 7
              },
              "withdrawalToken": {
                "type": "string",
                "id": 8
              },
              "invoiceToken": {
                "type": "string",
                "id": 11
              },
              "promotionalRewardToken": {
                "type": "string",
                "id": 13
              },
              "depositToken": {
                "type": "string",
                "id": 15
              },
              "exchangeDetail": {
                "type": ".squareup.bitty.ExchangeDetail",
                "id": 9
              },
              "withdrawal": {
                "type": ".squareup.bitty.Withdrawal",
                "id": 10
              },
              "invoice": {
                "type": ".squareup.bitty.Invoice",
                "id": 12
              },
              "promotionalReward": {
                "type": ".squareup.bitty.PromotionalReward",
                "id": 14
              },
              "deposit": {
                "type": ".squareup.bitty.Deposit",
                "id": 16
              }
            },
            "nested": {
              "detail_id": {
                "oneof": ["exchangeToken", "withdrawalToken", "invoiceToken", "promotionalRewardToken", "depositToken"]
              },
              "detail": {
                "oneof": ["exchangeDetail", "withdrawal", "invoice", "promotionalReward", "deposit"]
              }
            }
          },
          "UnitWithholdingConfig": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "withholdingEnabled": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "withholdingBps": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              },
              "eligibilityStatus": {
                "type": ".squareup.bitty.UnitWithholdingConfig.UnitEligibilityStatus",
                "id": 6,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 7,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 8,
                "rule": "optional"
              },
              "version": {
                "type": "int64",
                "id": 9,
                "rule": "optional"
              },
              "unitName": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              }
            },
            "nested": {
              "UnitEligibilityStatus": {
                "values": {
                  "DO_NOT_USE_UES": 0,
                  "ELIGIBLE": 1,
                  "DELETED": 2,
                  "INELIGIBLE_NY": 3,
                  "INELIGIBLE_US_TERRITORY": 4,
                  "INELIGIBLE_FROZEN": 5,
                  "INELIGIBLE_PAYMENT_DEACTIVATED": 6
                }
              }
            }
          },
          "UnitWithholdingConfigInfo": {
            "fields": {
              "minUnitWithholdingBps": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "maxUnitWithholdingBps": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "enabledLocationsCount": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "BitcoinAccount": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "version": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "withholdingEnabled": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "withholdingBps": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              },
              "currencyDisplayPreference": {
                "type": ".squareup.bitty.CurrencyDisplayPreference",
                "id": 6,
                "rule": "optional"
              },
              "unitLevelWithholdingEnabled": {
                "type": "bool",
                "id": 17,
                "rule": "optional"
              },
              "nextConversionTime": {
                "type": ".google.protobuf.Timestamp",
                "id": 7,
                "rule": "optional"
              },
              "btcPaybalAccountId": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "maxWithholdingBps": {
                "type": "int32",
                "id": 9,
                "rule": "optional"
              },
              "conversionFeeBps": {
                "type": "int32",
                "id": 10,
                "rule": "optional"
              },
              "bitcoinDisplayPreference": {
                "type": ".squareup.bitty.BitcoinDisplayPreference",
                "id": 11,
                "rule": "optional"
              },
              "status": {
                "type": ".squareup.bitty.BitcoinAccountStatus",
                "id": 12,
                "rule": "optional"
              },
              "cashCustomerToken": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "paymentSettings": {
                "type": ".squareup.bitty.PaymentSettings",
                "id": 14,
                "rule": "optional"
              },
              "onboardedConversionsAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 15,
                "rule": "optional"
              },
              "onboardedBtcMapAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 16,
                "rule": "optional"
              },
              "creationSource": {
                "type": "string",
                "id": 18,
                "rule": "optional"
              }
            }
          },
          "PaymentSettings": {
            "fields": {
              "btcMapEnabled": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "btcPaymentSettlementCurrency": {
                "type": ".squareup.common.CurrencyCode",
                "id": 2,
                "rule": "optional"
              },
              "paymentsEnabled": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "WalletDetails": {
            "fields": {
              "withholdingBalance": {
                "type": ".squareup.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "walletBalance": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "withholdingToWalletConversionRate": {
                "type": "int64",
                "id": 3,
                "rule": "optional"
              },
              "bitcoinDodPriceChange": {
                "type": "float",
                "id": 4,
                "rule": "optional"
              },
              "dailyLimit": {
                "type": ".squareup.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "dailyLimitProgress": {
                "type": ".squareup.common.Money",
                "id": 6,
                "rule": "optional"
              },
              "weeklyLimit": {
                "type": ".squareup.common.Money",
                "id": 7,
                "rule": "optional"
              },
              "weeklyLimitProgress": {
                "type": ".squareup.common.Money",
                "id": 8,
                "rule": "optional"
              },
              "manualBuyWeeklyLimit": {
                "type": ".squareup.common.Money",
                "id": 9,
                "rule": "optional"
              },
              "manualBuyWeeklyLimitProgress": {
                "type": ".squareup.common.Money",
                "id": 10,
                "rule": "optional"
              }
            }
          },
          "Withdrawal": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 2,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 3,
                "rule": "optional"
              },
              "version": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "amount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 6,
                "rule": "optional"
              },
              "usdEquivalentAmount": {
                "type": ".squareup.common.Money",
                "id": 7,
                "rule": "optional"
              },
              "usdEquivalentFee": {
                "type": ".squareup.common.Money",
                "id": 26,
                "rule": "optional"
              },
              "fee": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 8,
                "rule": "optional"
              },
              "flatRateFee": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 9,
                "rule": "optional"
              },
              "fiatEquivalentAmount": {
                "type": ".squareup.common.Money",
                "id": 10,
                "rule": "optional"
              },
              "fiatEquivalentFee": {
                "type": ".squareup.common.Money",
                "id": 25,
                "rule": "optional"
              },
              "fiatPricePerBtc": {
                "type": ".squareup.common.Money",
                "id": 32,
                "rule": "optional"
              },
              "simpleState": {
                "type": ".squareup.bitty.WithdrawalSimpleState",
                "id": 11,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.bitty.WithdrawalState",
                "id": 12,
                "rule": "optional"
              },
              "selectedSpeed": {
                "type": ".squareup.bitty.WithdrawalSpeed",
                "id": 13,
                "rule": "optional"
              },
              "feeMarginPercent": {
                "type": "int32",
                "id": 14,
                "rule": "optional"
              },
              "failureReason": {
                "type": ".squareup.bitty.WithdrawalFailureReason",
                "id": 15,
                "rule": "optional"
              },
              "sourceBalanceToken": {
                "type": "string",
                "id": 16,
                "rule": "optional"
              },
              "ledgerEntryToken": {
                "type": "string",
                "id": 17,
                "rule": "optional"
              },
              "destinationAddress": {
                "type": "string",
                "id": 18,
                "rule": "optional"
              },
              "blockTarget": {
                "type": "uint64",
                "id": 19,
                "rule": "optional"
              },
              "blockchainTransactionId": {
                "type": "string",
                "id": 20,
                "rule": "optional"
              },
              "blockchainTransactionOutputIndex": {
                "type": "uint32",
                "id": 27,
                "rule": "optional"
              },
              "source": {
                "type": "string",
                "id": 21,
                "rule": "optional"
              },
              "provider": {
                "type": "string",
                "id": 22,
                "rule": "optional"
              },
              "note": {
                "type": "string",
                "id": 23,
                "rule": "optional"
              },
              "userHasAcceptedRisk": {
                "type": "bool",
                "id": 24,
                "rule": "optional"
              },
              "reasonForWithdrawal": {
                "type": "string",
                "id": 28,
                "rule": "optional"
              },
              "selfAttestationDestination": {
                "type": "string",
                "id": 29,
                "rule": "optional"
              },
              "chosenWithdrawalSpeedOption": {
                "type": ".squareup.bitty.WithdrawalSpeedOption",
                "id": 30,
                "rule": "optional"
              },
              "feeRefunded": {
                "type": "bool",
                "id": 31,
                "rule": "optional"
              }
            }
          },
          "Deposit": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 2,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 3,
                "rule": "optional"
              },
              "version": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "amount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 6,
                "rule": "optional"
              },
              "usdEquivalentAmount": {
                "type": ".squareup.common.Money",
                "id": 7,
                "rule": "optional"
              },
              "fee": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 8,
                "rule": "optional"
              },
              "fiatEquivalentAmount": {
                "type": ".squareup.common.Money",
                "id": 9,
                "rule": "optional"
              },
              "fiatPricePerBtc": {
                "type": ".squareup.common.Money",
                "id": 10,
                "rule": "optional"
              },
              "simpleState": {
                "type": ".squareup.bitty.DepositSimpleState",
                "id": 11,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.bitty.DepositState",
                "id": 12,
                "rule": "optional"
              },
              "failureReason": {
                "type": ".squareup.bitty.DepositFailureReason",
                "id": 13,
                "rule": "optional"
              },
              "destinationBalanceToken": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "ledgerEntryToken": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              },
              "sourceAddress": {
                "type": "string",
                "id": 16,
                "rule": "optional"
              },
              "blockchainTransactionId": {
                "type": "string",
                "id": 17,
                "rule": "optional"
              },
              "blockchainTransactionOutputIndex": {
                "type": "uint32",
                "id": 18,
                "rule": "optional"
              },
              "confirmations": {
                "type": "uint32",
                "id": 19,
                "rule": "optional"
              },
              "requiredConfirmations": {
                "type": "uint32",
                "id": 20,
                "rule": "optional"
              },
              "source": {
                "type": "string",
                "id": 21,
                "rule": "optional"
              },
              "note": {
                "type": "string",
                "id": 22,
                "rule": "optional"
              },
              "reversed": {
                "type": "bool",
                "id": 23,
                "rule": "optional"
              },
              "reversalReason": {
                "type": "string",
                "id": 24,
                "rule": "optional"
              },
              "reversedAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 25,
                "rule": "optional"
              },
              "fiatEquivalentFee": {
                "type": ".squareup.common.Money",
                "id": 26,
                "rule": "optional"
              }
            }
          },
          "InvoiceState": {
            "values": {
              "DO_NOT_USE_IS": 0,
              "CREATED": 1,
              "PAID": 2,
              "EXPIRED": 3,
              "CANCELLED_INVOICE": 4,
              "ACCEPTED": 5
            }
          },
          "Invoice": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "paymentToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "fiatAmount": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "amountMilliSats": {
                "type": "uint64",
                "id": 5,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.bitty.InvoiceState",
                "id": 6,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 7,
                "rule": "optional"
              },
              "expirationTime": {
                "type": "int64",
                "id": 8,
                "rule": "optional"
              },
              "version": {
                "type": "int64",
                "id": 9,
                "rule": "optional"
              },
              "exchangeRate": {
                "type": "int64",
                "id": 10,
                "rule": "optional"
              },
              "feeAmount": {
                "type": ".squareup.common.Money",
                "id": 11,
                "rule": "optional"
              },
              "locationName": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "settlementCurrency": {
                "type": ".squareup.common.CurrencyCode",
                "id": 13,
                "rule": "optional"
              },
              "cashPaymentToken": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              }
            }
          },
          "FeeType": {
            "values": {
              "DO_NOT_USE_FEE_TYPE": 0,
              "ONE_PERCENT": 1,
              "FREE": 2,
              "POINT_FIVE_PERCENT": 3
            }
          },
          "ExchangeFeature": {
            "values": {
              "DO_NOT_USE_EXCHANGE_FEATURE": 0,
              "SELL_ALL": 1
            }
          },
          "Quote": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "bitcoinTransactionType": {
                "type": ".squareup.bitty.BitcoinTransactionType",
                "id": 3,
                "rule": "optional"
              },
              "exchangeRateAmount": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "fromAmount": {
                "type": ".squareup.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "toAmount": {
                "type": ".squareup.common.Money",
                "id": 6,
                "rule": "optional"
              },
              "feeAmount": {
                "type": ".squareup.common.Money",
                "id": 7,
                "rule": "optional"
              },
              "feeType": {
                "type": ".squareup.bitty.FeeType",
                "id": 8,
                "rule": "optional"
              },
              "expiresAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 9,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 10,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 11,
                "rule": "optional"
              },
              "exchangeFeature": {
                "type": ".squareup.bitty.ExchangeFeature",
                "id": 12,
                "rule": "optional"
              }
            }
          },
          "OwnWalletType": {
            "values": {
              "DO_NOT_USE_OWN_WALLET_TYPE": 0,
              "PERSONAL": 1,
              "THIRD_PARTY_SELF_CUSTODY": 2
            }
          },
          "ExchangeAccountType": {
            "values": {
              "DO_NOT_USE_EXCHANGE_ACCOUNT_TYPE": 0,
              "EXCHANGE_PERSONAL": 1,
              "EXCHANGE_THIRD_PARTY": 2
            }
          },
          "TrustHubExchangeName": {
            "values": {
              "DO_NOT_USE_TRUST_HUB_EXCHANGE_NAME": 0,
              "COINBASE": 1,
              "BINANCE": 2,
              "KRAKEN": 3,
              "AMBER_GROUP": 4,
              "AMINA_BANK_AG": 5,
              "APEX_NETWORK": 6,
              "APLO": 7,
              "AQUANOW": 8,
              "ARCHAX": 9,
              "ARIONE0": 10,
              "BACKPACK": 11,
              "BANKFRICK": 12,
              "BARE_BITCOIN_AS": 13,
              "BBVA": 14,
              "BCB_GROUP": 15,
              "BDACS": 16,
              "BEQUANT": 17,
              "BINGX": 18,
              "BIT2C": 19,
              "BIT2ME": 20,
              "BITBANK": 21,
              "BITBNS": 22,
              "BITCOIN4U": 23,
              "BITCOINPOINT": 24,
              "BITCOIN_DE": 25,
              "BITCOIN_SUISSE": 26,
              "BITCOVE": 27,
              "BITFINEX": 28,
              "BITGET": 29,
              "BITGO_TRUST": 30,
              "BITKUB_ONLINE": 31,
              "BITLOCUS": 32,
              "BITMART": 33,
              "BITMEX": 34,
              "BITPANDA": 35,
              "BITPAY": 36,
              "BITRUE": 37,
              "BITSTAMP": 38,
              "BITS_OF_GOLD": 39,
              "BITVAVO": 40,
              "BIT_PLUS": 41,
              "BLEAP_LTD": 42,
              "BLOCKBEE": 43,
              "BLOCKCHAIN_COM": 44,
              "BOERSE_STUTTGART_DIGITAL_CUSTODY": 45,
              "BOKU": 46,
              "BOOMFI": 47,
              "BRANE": 48,
              "BRIGHTY": 49,
              "BRIGHT_POINT_INTERNATIONAL_FUTURES": 50,
              "BTCBOX": 51,
              "BTCC": 52,
              "BTCTURK": 53,
              "BTC_DIRECT": 54,
              "CAPE_CRYPTO": 55,
              "CARRET": 56,
              "CASA": 57,
              "CEX": 58,
              "CEX_IO": 59,
              "CHANGE_NOW": 60,
              "CHECKSIG": 61,
              "CHIPPER_CASH": 62,
              "COFINEX": 63,
              "COINCAFE": 64,
              "COINEX": 65,
              "COINGATE": 66,
              "COINIFY": 67,
              "COINMATE": 68,
              "COINMETRO": 69,
              "COINMOTION": 70,
              "COINONE": 71,
              "COINPAYMENTS": 72,
              "COINSWITCH": 73,
              "COINS_PH": 74,
              "CONIO": 75,
              "CRESCENDO_CAPITAL": 76,
              "CRIPTAN": 77,
              "CROSSMINT": 78,
              "CRYPTOMARKET": 79,
              "CRYPTOWALLET": 80,
              "CRYPTO_COM": 81,
              "CRYPTO_FINANCE": 82,
              "CUBE_EXCHANGE": 83,
              "CYBAVO": 84,
              "DBS_BANK": 85,
              "DEPASIFY": 86,
              "DERIBIT": 87,
              "DFX": 88,
              "DIGTL": 89,
              "DLT_CUSTODY": 90,
              "EASY_CRYPTO": 91,
              "ECD_RS": 92,
              "ENCLAVE_MARKETS": 93,
              "ENIGMA": 94,
              "ETORO": 95,
              "FALCONX": 96,
              "FAZZ": 97,
              "FINCRYPTOU": 98,
              "FINOA": 99,
              "FINST": 100,
              "FIRI": 101,
              "FLOWDESK_SAS": 102,
              "FLOW_TRADERS": 103,
              "FORTUNA_DIGITAL_CUSTODY": 104,
              "FUTU": 105,
              "FV_BANK": 106,
              "GALAXY_DIGITAL": 107,
              "GATEHUB": 108,
              "GATE_IO": 109,
              "GIOTTUS": 110,
              "GMO_TRUST": 111,
              "GOIN": 112,
              "GREAT_SOUTH_GATE": 113,
              "HEX_TRUST_ITALIA_S_R_L_": 114,
              "HIDDEN_ROAD_PARTNERS": 115,
              "HTX": 116,
              "H_FINANCE": 117,
              "INDEPENDENT_RESERVE": 118,
              "ITBIT": 119,
              "IXFI": 120,
              "JANUAR": 121,
              "JUNO": 122,
              "KRIPTOMAT": 123,
              "KUCOIN": 124,
              "KUN": 125,
              "KYRREX": 126,
              "LCX": 127,
              "LEGEND_TRADING": 128,
              "LEMON": 129,
              "LMAX": 130,
              "LTP": 131,
              "LUSO_DIGITAL_ASSETS": 132,
              "M2": 133,
              "MATCH2PAY": 134,
              "MERCADO_BITCOIN": 135,
              "MEXC": 136,
              "MOBEE": 137,
              "MONEYBRAIN": 138,
              "NBX": 139,
              "NDAX": 140,
              "NEWTON": 141,
              "NEWTON_CRYPTO": 142,
              "NEXDESK": 143,
              "NEXO": 144,
              "NICEHASH": 145,
              "NILOS": 146,
              "NORDARK": 147,
              "NORTHCRYPTO": 148,
              "NYDIG": 149,
              "OKX": 150,
              "ONE_MONEY": 151,
              "OSL": 152,
              "PALISADE_FINANCIAL": 153,
              "PARFIN": 154,
              "PAXOS": 155,
              "PAYTRIE": 156,
              "PDAX": 157,
              "PHEMEX": 158,
              "PIONEX": 159,
              "QUANTFURY": 160,
              "REVOLUT": 161,
              "RIPIO": 162,
              "RISE": 163,
              "ROCKETFUEL": 164,
              "ROMA": 165,
              "SBI_ZODIA_CUSTODY": 166,
              "SWISSQUOTE_BANK": 167,
              "SWYFTX": 168,
              "SYGNUM": 169,
              "SYGNUM_BANK": 170,
              "T4TRADE": 171,
              "TANGANY": 172,
              "TAP": 173,
              "TAURUS": 174,
              "TILVEST": 175,
              "TOKYO_HASH": 176,
              "TORUMPAY": 177,
              "TRADESTATION": 178,
              "TRILLION_DIGITAL_ASSETS": 179,
              "UPBIT": 180,
              "UPHOLD": 181,
              "UPVEST": 182,
              "VALR": 183,
              "VAX": 184,
              "WALLET_TG": 185,
              "WHITEBIT": 186,
              "WIREX": 187,
              "WOO_X": 188,
              "XAPO_BANK": 189,
              "XBO_COM": 190,
              "XMONEY": 191,
              "XREX": 192,
              "XWHALE": 193,
              "YELLOW_CARD": 194,
              "YOUNG_PLATFORM": 195,
              "ZOOMEX": 196,
              "NONE_OF_THE_ABOVE": 197,
              "CASH_APP": 198
            }
          },
          "PromotionalReward": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "rewardType": {
                "type": ".squareup.bitty.PromotionalReward.PromotionalRewardType",
                "id": 3,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 4,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 5,
                "rule": "optional"
              },
              "version": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              },
              "fiatAmount": {
                "type": ".squareup.common.Money",
                "id": 7,
                "rule": "optional"
              },
              "bitcoinAmount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 9,
                "rule": "optional"
              },
              "exchangeRate": {
                "type": ".squareup.common.Money",
                "id": 10,
                "rule": "optional"
              },
              "grantedAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 11,
                "rule": "optional"
              },
              "vestedAt": {
                "type": ".google.protobuf.Timestamp",
                "id": 12,
                "rule": "optional"
              },
              "vestingDate": {
                "type": ".google.protobuf.Timestamp",
                "id": 13,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.bitty.PromotionalReward.PromotionalRewardState",
                "id": 14,
                "rule": "optional"
              },
              "consistentlyUsesConversionsStateData": {
                "type": ".squareup.bitty.ConsistentlyUsesConversionsStateData",
                "id": 15
              },
              "strictConsecutiveConversionsStateData": {
                "type": ".squareup.bitty.StrictConsecutiveConversionsStateData",
                "id": 16
              }
            },
            "nested": {
              "PromotionalRewardState": {
                "values": {
                  "DO_NOT_USE_PROMOTIONAL_REWARD_STATE": 0,
                  "PROMOTIONAL_REWARD_ELIGIBLE": 1,
                  "PROMOTIONAL_REWARD_GRANTED": 2,
                  "PROMOTIONAL_REWARD_VESTED": 3,
                  "PROMOTIONAL_REWARD_CANCELLED": 4
                }
              },
              "PromotionalRewardType": {
                "values": {
                  "DO_NOT_USE_PROMOTIONAL_REWARD_TYPE": 0,
                  "CONSISTENTLY_USES_CONVERSIONS": 1,
                  "STRICT_CONSECUTIVE_CONVERSIONS": 2
                }
              },
              "state_data": {
                "oneof": ["consistentlyUsesConversionsStateData", "strictConsecutiveConversionsStateData"]
              }
            }
          },
          "ConsistentlyUsesConversionsStateData": {
            "fields": {
              "monthlyConversions": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "StrictConsecutiveConversionsStateData": {
            "fields": {
              "firstConversionMonth": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "monthlyConversions": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ConversionUnitContribution": {
            "fields": {
              "exchangeToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "fiatAmount": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "bitcoinAmount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 5,
                "rule": "optional"
              },
              "withholdingBpsAtConvTime": {
                "type": "int32",
                "id": 6,
                "rule": "optional"
              },
              "nickname": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bitty?.nested?.RequirementId && !$root.nested?.squareup?.nested?.bitty?.nested?.ResultCode && !$root.nested?.squareup?.nested?.bitty?.nested?.UserInteraction && !$root.nested?.squareup?.nested?.bitty?.nested?.Hurdle && !$root.nested?.squareup?.nested?.bitty?.nested?.AmountHurdle && !$root.nested?.squareup?.nested?.bitty?.nested?.MaximumAmountReason && !$root.nested?.squareup?.nested?.bitty?.nested?.ConfirmationHurdle && !$root.nested?.squareup?.nested?.bitty?.nested?.NoteHurdle && !$root.nested?.squareup?.nested?.bitty?.nested?.ScamWarningHurdle && !$root.nested?.squareup?.nested?.bitty?.nested?.SelfAttestationHurdle && !$root.nested?.squareup?.nested?.bitty?.nested?.TargetWalletAddressHurdle && !$root.nested?.squareup?.nested?.bitty?.nested?.SpeedHurdle && !$root.nested?.squareup?.nested?.bitty?.nested?.WithdrawalReasonHurdle && !$root.nested?.squareup?.nested?.bitty?.nested?.Notification && !$root.nested?.squareup?.nested?.bitty?.nested?.CancelledNotification && !$root.nested?.squareup?.nested?.bitty?.nested?.SanctionsHeldNotification && !$root.nested?.squareup?.nested?.bitty?.nested?.SubmittedOnChainNotification && !$root.nested?.squareup?.nested?.bitty?.nested?.WithdrawalAction && !$root.nested?.squareup?.nested?.bitty?.nested?.SpeedActionData && !$root.nested?.squareup?.nested?.bitty?.nested?.WithdrawalReasonActionData && !$root.nested?.squareup?.nested?.bitty?.nested?.AmountActionData && !$root.nested?.squareup?.nested?.bitty?.nested?.NoteActionData && !$root.nested?.squareup?.nested?.bitty?.nested?.SelfAttestationActionData && !$root.nested?.squareup?.nested?.bitty?.nested?.ExchangeAccount && !$root.nested?.squareup?.nested?.bitty?.nested?.TargetWalletAddressActionData && !$root.nested?.squareup?.nested?.bitty?.nested?.WithdrawalSpeedOption && !$root.nested?.squareup?.nested?.bitty?.nested?.SelfAttestationExchangeOption && !$root.nested?.squareup?.nested?.bitty?.nested?.WithdrawalSimpleState && !$root.nested?.squareup?.nested?.bitty?.nested?.DepositSimpleState && !$root.nested?.squareup?.nested?.bitty?.nested?.WithdrawalState && !$root.nested?.squareup?.nested?.bitty?.nested?.DepositState && !$root.nested?.squareup?.nested?.bitty?.nested?.WithdrawalFailureReason && !$root.nested?.squareup?.nested?.bitty?.nested?.DepositFailureReason && !$root.nested?.squareup?.nested?.bitty?.nested?.WithdrawalSpeed && !$root.nested?.squareup?.nested?.bitty?.nested?.ExchangeDetail && !$root.nested?.squareup?.nested?.bitty?.nested?.ExchangeDetail?.nested?.ExchangeType && !$root.nested?.squareup?.nested?.bitty?.nested?.ExchangeDetail?.nested?.ExchangeState && !$root.nested?.squareup?.nested?.bitty?.nested?.ExchangeDetail?.nested?.ConversionData && !$root.nested?.squareup?.nested?.bitty?.nested?.BitcoinTransactionType && !$root.nested?.squareup?.nested?.bitty?.nested?.BitcoinTransactionType?.nested?.PaymentType && !$root.nested?.squareup?.nested?.bitty?.nested?.SourceTargetBalance && !$root.nested?.squareup?.nested?.bitty?.nested?.Endpoint && !$root.nested?.squareup?.nested?.bitty?.nested?.BusinessType && !$root.nested?.squareup?.nested?.bitty?.nested?.CurrencyDisplayPreference && !$root.nested?.squareup?.nested?.bitty?.nested?.BitcoinAccountStatus && !$root.nested?.squareup?.nested?.bitty?.nested?.BtcKybStatus && !$root.nested?.squareup?.nested?.bitty?.nested?.BitcoinDisplayPreference && !$root.nested?.squareup?.nested?.bitty?.nested?.BitcoinPaymentsStatus && !$root.nested?.squareup?.nested?.bitty?.nested?.BitcoinActivity && !$root.nested?.squareup?.nested?.bitty?.nested?.UnitWithholdingConfig && !$root.nested?.squareup?.nested?.bitty?.nested?.UnitWithholdingConfig?.nested?.UnitEligibilityStatus && !$root.nested?.squareup?.nested?.bitty?.nested?.UnitWithholdingConfigInfo && !$root.nested?.squareup?.nested?.bitty?.nested?.BitcoinAccount && !$root.nested?.squareup?.nested?.bitty?.nested?.PaymentSettings && !$root.nested?.squareup?.nested?.bitty?.nested?.WalletDetails && !$root.nested?.squareup?.nested?.bitty?.nested?.Withdrawal && !$root.nested?.squareup?.nested?.bitty?.nested?.Deposit && !$root.nested?.squareup?.nested?.bitty?.nested?.InvoiceState && !$root.nested?.squareup?.nested?.bitty?.nested?.Invoice && !$root.nested?.squareup?.nested?.bitty?.nested?.FeeType && !$root.nested?.squareup?.nested?.bitty?.nested?.ExchangeFeature && !$root.nested?.squareup?.nested?.bitty?.nested?.Quote && !$root.nested?.squareup?.nested?.bitty?.nested?.OwnWalletType && !$root.nested?.squareup?.nested?.bitty?.nested?.ExchangeAccountType && !$root.nested?.squareup?.nested?.bitty?.nested?.TrustHubExchangeName && !$root.nested?.squareup?.nested?.bitty?.nested?.PromotionalReward && !$root.nested?.squareup?.nested?.bitty?.nested?.PromotionalReward?.nested?.PromotionalRewardState && !$root.nested?.squareup?.nested?.bitty?.nested?.PromotionalReward?.nested?.PromotionalRewardType && !$root.nested?.squareup?.nested?.bitty?.nested?.ConsistentlyUsesConversionsStateData && !$root.nested?.squareup?.nested?.bitty?.nested?.StrictConsecutiveConversionsStateData && !$root.nested?.squareup?.nested?.bitty?.nested?.ConversionUnitContribution) {
  $root.addJSON(jsonData);
}

/**
 * Enum representing the requirement IDs for different steps
 *
 * SOURCE RequirementId @ squareup/bitty/model.proto at 22:1
 */
export const RequirementId = $root.lookupEnum('squareup.bitty.RequirementId').values;
/**
 * Enum representing the result codes for step completion
 *
 * SOURCE ResultCode @ squareup/bitty/model.proto at 41:1
 */
export const ResultCode = $root.lookupEnum('squareup.bitty.ResultCode').values;
/**
 * SOURCE UserInteraction @ squareup/bitty/model.proto at 52:1
 */
export const UserInteraction = $root.lookupType('squareup.bitty.UserInteraction');
fixType(UserInteraction);
Builder.createAndAttachToType(UserInteraction);
/**
 * === Hurdles ===
 *
 * SOURCE Hurdle @ squareup/bitty/model.proto at 63:1
 */
export const Hurdle = $root.lookupType('squareup.bitty.Hurdle');
fixType(Hurdle);
Builder.createAndAttachToType(Hurdle);
/**
 * SOURCE AmountHurdle @ squareup/bitty/model.proto at 76:1
 */
export const AmountHurdle = $root.lookupType('squareup.bitty.AmountHurdle');
fixType(AmountHurdle);
Builder.createAndAttachToType(AmountHurdle);
/**
 * SOURCE MaximumAmountReason @ squareup/bitty/model.proto at 88:1
 */
export const MaximumAmountReason = $root.lookupEnum('squareup.bitty.MaximumAmountReason').values;
/**
 * SOURCE ConfirmationHurdle @ squareup/bitty/model.proto at 96:1
 */
export const ConfirmationHurdle = $root.lookupType('squareup.bitty.ConfirmationHurdle');
fixType(ConfirmationHurdle);
Builder.createAndAttachToType(ConfirmationHurdle);
/**
 * SOURCE NoteHurdle @ squareup/bitty/model.proto at 110:1
 */
export const NoteHurdle = $root.lookupType('squareup.bitty.NoteHurdle');
fixType(NoteHurdle);
Builder.createAndAttachToType(NoteHurdle);
/**
 * SOURCE ScamWarningHurdle @ squareup/bitty/model.proto at 114:1
 */
export const ScamWarningHurdle = $root.lookupType('squareup.bitty.ScamWarningHurdle');
fixType(ScamWarningHurdle);
Builder.createAndAttachToType(ScamWarningHurdle);
/**
 * SOURCE SelfAttestationHurdle @ squareup/bitty/model.proto at 115:1
 */
export const SelfAttestationHurdle = $root.lookupType('squareup.bitty.SelfAttestationHurdle');
fixType(SelfAttestationHurdle);
Builder.createAndAttachToType(SelfAttestationHurdle);
/**
 * SOURCE TargetWalletAddressHurdle @ squareup/bitty/model.proto at 119:1
 */
export const TargetWalletAddressHurdle = $root.lookupType('squareup.bitty.TargetWalletAddressHurdle');
fixType(TargetWalletAddressHurdle);
Builder.createAndAttachToType(TargetWalletAddressHurdle);
/**
 * SOURCE SpeedHurdle @ squareup/bitty/model.proto at 123:1
 */
export const SpeedHurdle = $root.lookupType('squareup.bitty.SpeedHurdle');
fixType(SpeedHurdle);
Builder.createAndAttachToType(SpeedHurdle);
/**
 * SOURCE WithdrawalReasonHurdle @ squareup/bitty/model.proto at 130:1
 */
export const WithdrawalReasonHurdle = $root.lookupType('squareup.bitty.WithdrawalReasonHurdle');
fixType(WithdrawalReasonHurdle);
Builder.createAndAttachToType(WithdrawalReasonHurdle);
/**
 * === Notifications ===
 *
 * SOURCE Notification @ squareup/bitty/model.proto at 136:1
 */
export const Notification = $root.lookupType('squareup.bitty.Notification');
fixType(Notification);
Builder.createAndAttachToType(Notification);
/**
 * SOURCE CancelledNotification @ squareup/bitty/model.proto at 144:1
 */
export const CancelledNotification = $root.lookupType('squareup.bitty.CancelledNotification');
fixType(CancelledNotification);
Builder.createAndAttachToType(CancelledNotification);
/**
 * SOURCE SanctionsHeldNotification @ squareup/bitty/model.proto at 145:1
 */
export const SanctionsHeldNotification = $root.lookupType('squareup.bitty.SanctionsHeldNotification');
fixType(SanctionsHeldNotification);
Builder.createAndAttachToType(SanctionsHeldNotification);
/**
 * SOURCE SubmittedOnChainNotification @ squareup/bitty/model.proto at 146:1
 */
export const SubmittedOnChainNotification = $root.lookupType('squareup.bitty.SubmittedOnChainNotification');
fixType(SubmittedOnChainNotification);
Builder.createAndAttachToType(SubmittedOnChainNotification);
/**
 * === Actions ===
 * Represents the result of completing a step
 *
 * SOURCE WithdrawalAction @ squareup/bitty/model.proto at 157:1
 */
export const WithdrawalAction = $root.lookupType('squareup.bitty.WithdrawalAction');
fixType(WithdrawalAction);
Builder.createAndAttachToType(WithdrawalAction);
/**
 * Data specific to Speed step action
 *
 * SOURCE SpeedActionData @ squareup/bitty/model.proto at 175:1
 */
export const SpeedActionData = $root.lookupType('squareup.bitty.SpeedActionData');
fixType(SpeedActionData);
Builder.createAndAttachToType(SpeedActionData);
/**
 * SOURCE WithdrawalReasonActionData @ squareup/bitty/model.proto at 179:1
 */
export const WithdrawalReasonActionData = $root.lookupType('squareup.bitty.WithdrawalReasonActionData');
fixType(WithdrawalReasonActionData);
Builder.createAndAttachToType(WithdrawalReasonActionData);
/**
 * SOURCE AmountActionData @ squareup/bitty/model.proto at 183:1
 */
export const AmountActionData = $root.lookupType('squareup.bitty.AmountActionData');
fixType(AmountActionData);
Builder.createAndAttachToType(AmountActionData);
/**
 * SOURCE NoteActionData @ squareup/bitty/model.proto at 187:1
 */
export const NoteActionData = $root.lookupType('squareup.bitty.NoteActionData');
fixType(NoteActionData);
Builder.createAndAttachToType(NoteActionData);
/**
 * SOURCE SelfAttestationActionData @ squareup/bitty/model.proto at 191:1
 */
export const SelfAttestationActionData = $root.lookupType('squareup.bitty.SelfAttestationActionData');
fixType(SelfAttestationActionData);
Builder.createAndAttachToType(SelfAttestationActionData);
/**
 * SOURCE ExchangeAccount @ squareup/bitty/model.proto at 200:1
 */
export const ExchangeAccount = $root.lookupType('squareup.bitty.ExchangeAccount');
fixType(ExchangeAccount);
Builder.createAndAttachToType(ExchangeAccount);
/**
 * SOURCE TargetWalletAddressActionData @ squareup/bitty/model.proto at 205:1
 */
export const TargetWalletAddressActionData = $root.lookupType('squareup.bitty.TargetWalletAddressActionData');
fixType(TargetWalletAddressActionData);
Builder.createAndAttachToType(TargetWalletAddressActionData);
/**
 * SOURCE WithdrawalSpeedOption @ squareup/bitty/model.proto at 209:1
 */
export const WithdrawalSpeedOption = $root.lookupType('squareup.bitty.WithdrawalSpeedOption');
fixType(WithdrawalSpeedOption);
Builder.createAndAttachToType(WithdrawalSpeedOption);
/**
 * SOURCE SelfAttestationExchangeOption @ squareup/bitty/model.proto at 219:1
 */
export const SelfAttestationExchangeOption = $root.lookupType('squareup.bitty.SelfAttestationExchangeOption');
fixType(SelfAttestationExchangeOption);
Builder.createAndAttachToType(SelfAttestationExchangeOption);
/**
 * State of withdrawal to be displayed to user
 *
 * SOURCE WithdrawalSimpleState @ squareup/bitty/model.proto at 226:1
 */
export const WithdrawalSimpleState = $root.lookupEnum('squareup.bitty.WithdrawalSimpleState').values;
/**
 * State of deposit to be displayed to user
 *
 * SOURCE DepositSimpleState @ squareup/bitty/model.proto at 244:1
 */
export const DepositSimpleState = $root.lookupEnum('squareup.bitty.DepositSimpleState').values;
/**
 * Internal state of withdrawal
 *
 * SOURCE WithdrawalState @ squareup/bitty/model.proto at 260:1
 */
export const WithdrawalState = $root.lookupEnum('squareup.bitty.WithdrawalState').values;
/**
 * Internal state of deposit
 *
 * SOURCE DepositState @ squareup/bitty/model.proto at 304:1
 */
export const DepositState = $root.lookupEnum('squareup.bitty.DepositState').values;
/**
 * Reasons a withdrawal can fail.
 *
 * SOURCE WithdrawalFailureReason @ squareup/bitty/model.proto at 353:1
 */
export const WithdrawalFailureReason = $root.lookupEnum('squareup.bitty.WithdrawalFailureReason').values;
/**
 * Reasons a deposit can fail.
 *
 * SOURCE DepositFailureReason @ squareup/bitty/model.proto at 403:1
 */
export const DepositFailureReason = $root.lookupEnum('squareup.bitty.DepositFailureReason').values;
/**
 * SOURCE WithdrawalSpeed @ squareup/bitty/model.proto at 438:1
 */
export const WithdrawalSpeed = $root.lookupEnum('squareup.bitty.WithdrawalSpeed').values;
/**
 * SOURCE ExchangeDetail @ squareup/bitty/model.proto at 445:1
 */
export const ExchangeDetail = $root.lookupType('squareup.bitty.ExchangeDetail');
fixType(ExchangeDetail);
Builder.createAndAttachToType(ExchangeDetail);
/**
 * SOURCE ExchangeType @ squareup/bitty/model.proto at 446:3
 */
ExchangeDetail.ExchangeType = $root.lookupEnum('squareup.bitty.ExchangeDetail.ExchangeType').values;
/**
 * SOURCE ExchangeState @ squareup/bitty/model.proto at 461:3
 */
ExchangeDetail.ExchangeState = $root.lookupEnum('squareup.bitty.ExchangeDetail.ExchangeState').values;
/**
 * SOURCE ConversionData @ squareup/bitty/model.proto at 524:3
 */
ExchangeDetail.ConversionData = $root.lookupType('squareup.bitty.ExchangeDetail.ConversionData');
fixType(ExchangeDetail.ConversionData);
Builder.createAndAttachToType(ExchangeDetail.ConversionData);
/**
 * SOURCE BitcoinTransactionType @ squareup/bitty/model.proto at 531:1
 */
export const BitcoinTransactionType = $root.lookupType('squareup.bitty.BitcoinTransactionType');
fixType(BitcoinTransactionType);
Builder.createAndAttachToType(BitcoinTransactionType);
/**
 * SOURCE PaymentType @ squareup/bitty/model.proto at 532:3
 */
BitcoinTransactionType.PaymentType = $root.lookupEnum('squareup.bitty.BitcoinTransactionType.PaymentType').values;
/**
 * Source/target balance for buy/sell
 *
 * SOURCE SourceTargetBalance @ squareup/bitty/model.proto at 544:1
 */
export const SourceTargetBalance = $root.lookupType('squareup.bitty.SourceTargetBalance');
fixType(SourceTargetBalance);
Builder.createAndAttachToType(SourceTargetBalance);
/**
 * Enum representing the endpoint to call to clear next steps
 *
 * SOURCE Endpoint @ squareup/bitty/model.proto at 551:1
 */
export const Endpoint = $root.lookupEnum('squareup.bitty.Endpoint').values;
/**
 * SOURCE BusinessType @ squareup/bitty/model.proto at 560:1
 */
export const BusinessType = $root.lookupEnum('squareup.bitty.BusinessType').values;
/**
 * SOURCE CurrencyDisplayPreference @ squareup/bitty/model.proto at 581:1
 */
export const CurrencyDisplayPreference = $root.lookupEnum('squareup.bitty.CurrencyDisplayPreference').values;
/**
 * Represents the status for a Bitcoin account
 *
 * SOURCE BitcoinAccountStatus @ squareup/bitty/model.proto at 591:1
 */
export const BitcoinAccountStatus = $root.lookupEnum('squareup.bitty.BitcoinAccountStatus').values;
/**
 * SOURCE BtcKybStatus @ squareup/bitty/model.proto at 620:1
 */
export const BtcKybStatus = $root.lookupEnum('squareup.bitty.BtcKybStatus').values;
/**
 * SOURCE BitcoinDisplayPreference @ squareup/bitty/model.proto at 633:1
 */
export const BitcoinDisplayPreference = $root.lookupEnum('squareup.bitty.BitcoinDisplayPreference').values;
/**
 * SOURCE BitcoinPaymentsStatus @ squareup/bitty/model.proto at 642:1
 */
export const BitcoinPaymentsStatus = $root.lookupEnum('squareup.bitty.BitcoinPaymentsStatus').values;
/**
 * SOURCE BitcoinActivity @ squareup/bitty/model.proto at 665:1
 */
export const BitcoinActivity = $root.lookupType('squareup.bitty.BitcoinActivity');
fixType(BitcoinActivity);
Builder.createAndAttachToType(BitcoinActivity);
/**
 * SOURCE UnitWithholdingConfig @ squareup/bitty/model.proto at 708:1
 */
export const UnitWithholdingConfig = $root.lookupType('squareup.bitty.UnitWithholdingConfig');
fixType(UnitWithholdingConfig);
Builder.createAndAttachToType(UnitWithholdingConfig);
/**
 * SOURCE UnitEligibilityStatus @ squareup/bitty/model.proto at 709:3
 */
UnitWithholdingConfig.UnitEligibilityStatus = $root.lookupEnum('squareup.bitty.UnitWithholdingConfig.UnitEligibilityStatus').values;
/**
 * SOURCE UnitWithholdingConfigInfo @ squareup/bitty/model.proto at 746:1
 */
export const UnitWithholdingConfigInfo = $root.lookupType('squareup.bitty.UnitWithholdingConfigInfo');
fixType(UnitWithholdingConfigInfo);
Builder.createAndAttachToType(UnitWithholdingConfigInfo);
/**
 * SOURCE BitcoinAccount @ squareup/bitty/model.proto at 755:1
 */
export const BitcoinAccount = $root.lookupType('squareup.bitty.BitcoinAccount');
fixType(BitcoinAccount);
Builder.createAndAttachToType(BitcoinAccount);
/**
 * SOURCE PaymentSettings @ squareup/bitty/model.proto at 797:1
 */
export const PaymentSettings = $root.lookupType('squareup.bitty.PaymentSettings');
fixType(PaymentSettings);
Builder.createAndAttachToType(PaymentSettings);
/**
 * SOURCE WalletDetails @ squareup/bitty/model.proto at 811:1
 */
export const WalletDetails = $root.lookupType('squareup.bitty.WalletDetails');
fixType(WalletDetails);
Builder.createAndAttachToType(WalletDetails);
/**
 * A complete record of a customer-initiated Bitcoin withdrawal.
 *
 * Field names, ordering, and comments are kept in-step with the Kotlin
 * data class to make future maintenance straightforward.
 *
 * SOURCE Withdrawal @ squareup/bitty/model.proto at 840:1
 */
export const Withdrawal = $root.lookupType('squareup.bitty.Withdrawal');
fixType(Withdrawal);
Builder.createAndAttachToType(Withdrawal);
/**
 * A complete record of a Bitcoin deposit.
 *
 * Field names, ordering, and comments mirror the structure of Withdrawal
 * to maintain consistency across money movement operations.
 *
 * SOURCE Deposit @ squareup/bitty/model.proto at 965:1
 */
export const Deposit = $root.lookupType('squareup.bitty.Deposit');
fixType(Deposit);
Builder.createAndAttachToType(Deposit);
/**
 * SOURCE InvoiceState @ squareup/bitty/model.proto at 1067:1
 */
export const InvoiceState = $root.lookupEnum('squareup.bitty.InvoiceState').values;
/**
 * SOURCE Invoice @ squareup/bitty/model.proto at 1082:1
 */
export const Invoice = $root.lookupType('squareup.bitty.Invoice');
fixType(Invoice);
Builder.createAndAttachToType(Invoice);
/**
 * SOURCE FeeType @ squareup/bitty/model.proto at 1129:1
 */
export const FeeType = $root.lookupEnum('squareup.bitty.FeeType').values;
/**
 * Distinct from ExchangeType,
 * ExchangeFeature will express special features of an exchange
 *
 * SOURCE ExchangeFeature @ squareup/bitty/model.proto at 1142:1
 */
export const ExchangeFeature = $root.lookupEnum('squareup.bitty.ExchangeFeature').values;
/**
 * SOURCE Quote @ squareup/bitty/model.proto at 1149:1
 */
export const Quote = $root.lookupType('squareup.bitty.Quote');
fixType(Quote);
Builder.createAndAttachToType(Quote);
/**
 * SOURCE OwnWalletType @ squareup/bitty/model.proto at 1187:1
 */
export const OwnWalletType = $root.lookupEnum('squareup.bitty.OwnWalletType').values;
/**
 * SOURCE ExchangeAccountType @ squareup/bitty/model.proto at 1195:1
 */
export const ExchangeAccountType = $root.lookupEnum('squareup.bitty.ExchangeAccountType').values;
/**
 * SOURCE TrustHubExchangeName @ squareup/bitty/model.proto at 1203:1
 */
export const TrustHubExchangeName = $root.lookupEnum('squareup.bitty.TrustHubExchangeName').values;
/**
 * SOURCE PromotionalReward @ squareup/bitty/model.proto at 1405:1
 */
export const PromotionalReward = $root.lookupType('squareup.bitty.PromotionalReward');
fixType(PromotionalReward);
Builder.createAndAttachToType(PromotionalReward);
/**
 * Enum representing the states of a promotional reward
 *
 * SOURCE PromotionalRewardState @ squareup/bitty/model.proto at 1407:3
 */
PromotionalReward.PromotionalRewardState = $root.lookupEnum('squareup.bitty.PromotionalReward.PromotionalRewardState').values;
/**
 * Enum representing the types of promotional rewards
 *
 * SOURCE PromotionalRewardType @ squareup/bitty/model.proto at 1421:3
 */
PromotionalReward.PromotionalRewardType = $root.lookupEnum('squareup.bitty.PromotionalReward.PromotionalRewardType').values;
/**
 * State data for the ConsistentlyUsesConversions reward
 *
 * SOURCE ConsistentlyUsesConversionsStateData @ squareup/bitty/model.proto at 1477:1
 */
export const ConsistentlyUsesConversionsStateData = $root.lookupType('squareup.bitty.ConsistentlyUsesConversionsStateData');
fixType(ConsistentlyUsesConversionsStateData);
Builder.createAndAttachToType(ConsistentlyUsesConversionsStateData);
/**
 * State data for the StrictConsecutiveConversions reward
 *
 * SOURCE StrictConsecutiveConversionsStateData @ squareup/bitty/model.proto at 1483:1
 */
export const StrictConsecutiveConversionsStateData = $root.lookupType('squareup.bitty.StrictConsecutiveConversionsStateData');
fixType(StrictConsecutiveConversionsStateData);
Builder.createAndAttachToType(StrictConsecutiveConversionsStateData);
/**
 * SOURCE ConversionUnitContribution @ squareup/bitty/model.proto at 1490:1
 */
export const ConversionUnitContribution = $root.lookupType('squareup.bitty.ConversionUnitContribution');
fixType(ConversionUnitContribution);
Builder.createAndAttachToType(ConversionUnitContribution);